import React from 'react';
import { StepInteraction } from '../../lib/types';

interface ScenarioInteractionHintProps {
  interaction: StepInteraction;
}

const hintTextFor = (interaction: StepInteraction): string => {
  switch (interaction.kind) {
    case 'scrub-year':
      return `Scrub the year slider (${interaction.from}–${interaction.to}) to see the trajectory.`;
  }
};

export const ScenarioInteractionHint: React.FC<ScenarioInteractionHintProps> = ({
  interaction,
}) => {
  return (
    <div className="border-l-2 border-figma-yellow pl-3 py-1">
      <p className="text-body-sm font-roboto text-neutral-300">
        <span className="mr-1.5" aria-hidden="true">💡</span>
        {hintTextFor(interaction)}
      </p>
    </div>
  );
};
